<pace-core-side-menu>
    <pace-weekly-work-time
        paceWeeklyWorkTime
        *ngIf="displayWeeklyWorkTime"
        [isWorkStartedForToday]="isStartWorkAlreadySet"
    ></pace-weekly-work-time>
    <pace-information paceInformation></pace-information>
    <pace-core-menu-entry
        *ngIf="showCorporateEntry"
        corporateInformationMenuEntry
        [model]="corporateInformationEntry"
    ></pace-core-menu-entry>
</pace-core-side-menu>
<pace-core-navigation-link></pace-core-navigation-link>
<!-- Display numberOfMaterialsToBeReturned -->
<pace-return-material></pace-return-material>
<pace-core-whats-new></pace-core-whats-new>
<div class="gid px-3 py-0 d-none d-lg-block">
    <fa-icon [icon]="faUser"></fa-icon><span> {{ gid }}</span>
</div>
<pace-core-sync-indicator *ngIf="displaySync"></pace-core-sync-indicator>
